



































































































































import Vue from 'vue'
import Component from 'vue-class-component'
import { PaymentsModule } from '@/store/modules/payments.module'
import { getModule } from 'vuex-module-decorators'
import {
  EPaymentMethodType,
  EPaymentStatus,
  EUserPermissions,
  IFacility,
  IPayment,
  IPaymentStatus,
  IResident,
  IResidentPaymentMethod
} from '@zunta/configurations'
import { User } from '@/classes/User'
import Api from '@/api'
import AddressesPopup from '@/views/app/management/components/AddressesPopup.vue'
import RefundPopup from '@/views/app/management/components/RefundPopup.vue'
import DropdownNav from '@/components/DropdownNav.vue'
import DateTimeLabel from '@/components/labels/DateTimeLabel.vue'
import Icon from '@/components/Icon.vue'
import { getPaidByLabel } from '@/utils/helpers'
import Card from '@/components/Card.vue'
import Table from '@/components/tables/Table.vue'
import ResidentPaymentHistorySubrow
  from '@/views/app/management/residents/resident-page/components/ResidentPaymentHistorySubrow.vue'
import { ETableColumnType, ITableConfig } from '@/interfaces'
import StatusPayment from '@/components/statuses/StatusPayment.vue'
import { PAYMENT_STATUSES_LABEL_MAP } from '@/constants'
import PaymentMethodLabel from '@/components/labels/PaymentMethodLabel.vue'
import { VPopover } from 'v-tooltip'

@Component({
  props: {
    resident: {
      type: Number
    },
    minHeight: {
      type: String
    },
    maxHeight: {
      type: String
    }
  },
  components: {
    PaymentMethodLabel,
    StatusPayment,
    ResidentPaymentHistorySubrow,
    Table,
    Card,
    Icon,
    DateTimeLabel,
    DropdownNav,
    RefundPopup,
    AddressesPopup,
    VPopover
  }
})
export default class ResidentPaymentHistory extends Vue {
  paymentsModuleInstance: PaymentsModule = getModule(PaymentsModule, this.$store)
  EUserPermissions: any = EUserPermissions
  EPaymentStatus: any = EPaymentStatus
  user: User = Api.getUser() as User
  getPaidByLabel: any = getPaidByLabel

  refundPayment: any = null

  receiptPaymentId: number = -1
  openedRowIndex: any = -1
  openedStatus: any = -1

  config: ITableConfig = {
    clearFilterBtn: {
      wrapperClass: 'position-absolute',
      wrapperStyle: 'top: calc(-1rem - 1px); right: -1.5rem;',
      class: 'rounded-bottom'
    },
    useQuery: false,
    usePagination: true,
    useSubrow: true,
    fetchFunction: this.fetchResidentPayments,
    rowClick: this.showPaymentTransactions,
    maxHeight: this.$props.maxHeight,
    minHeight: this.$props.minHeight,
    columns: [
      {
        minWidth: '70px',
        width: 6,
        key: 'id',
        searchKey: 'willowPaymentId',
        hasSort: true,
        hasSearch: true,
        label: 'Payment Id',
        type: ETableColumnType.default
      },
      {
        class: '',
        minWidth: '120px',
        width: 12,
        key: 'paidDate',
        searchKey: 'paidDate',
        hasSort: true,
        hasSearch: true,
        label: 'Date',
        type: ETableColumnType.dateRange
      },
      {
        headClass: 'bt-justify-content-end',
        class: 'text-right',
        minWidth: '100px',
        width: 15,
        key: 'amountPaid',
        searchKey: 'amountPaid',
        hasSort: true,
        hasSearch: true,
        label: 'Amount',
        type: ETableColumnType.numberRange
      },
      {
        minWidth: '120px',
        width: 20,
        key: 'paymentMethod',
        searchKey: 'paymentMethod',
        hasSort: true,
        hasSearch: true,
        label: 'Payment Method',
        type: ETableColumnType.default
      },
      {
        minWidth: '100px',
        width: 22,
        key: 'processedBy',
        searchKey: 'processedBy',
        hasSort: true,
        hasSearch: true,
        label: 'Processed By',
        type: ETableColumnType.default
      },
      {
        minWidth: '120px',
        width: 15,
        key: 'status',
        searchKey: 'status',
        hasSort: true,
        hasSearch: true,
        label: 'Status',
        type: ETableColumnType.multiselect,
        options: this.paymentsStatusesList()
      },
      {
        class: 'bt-d-flex bt-align-items-center bt-justify-content-end',
        minWidth: '80px',
        width: 10,
        key: 'actions',
        hasSort: false,
        hasSearch: false
      }
    ]
  }

  get residentId () {
    return this.$route.params.id
  }

  get selectedResident () {
    return this.$store.state.resident.selectedResident
  }

  get paymentsTotal () {
    return this.$store.state.payments.total
  }

  get paymentStatusList () {
    return this.$store.state.payments.paymentStatusList
  }

  paymentsStatusesList () {
    return Object.values(EPaymentStatus).map((status: any) => ({
      value: status,
      content: PAYMENT_STATUSES_LABEL_MAP[status],
      key: status
    }))
  }

  get residentPaymentOptions () {
    const options = [
      {
        value: 'payment-one-time',
        key: 'payment-one-time',
        content: 'One time'
      }
    ]
    if (this.user.hasPermissionFor(EUserPermissions.CREATE_AUTOPAY)) {
      options.push({
        value: 'payment-autopay',
        key: 'payment-autopay',
        content: 'Autopay'
      })
    }
    return options
  }

  get isUserCanRefund (): boolean {
    return this.user.hasPermissionFor(EUserPermissions.REFUND_PAYMENT)
  }

  async fetchResidentPayments (filters: any) {
    this.openedRowIndex = -1
    await this.paymentsModuleInstance.getResidentPaymentsList({
      residentId: this.$props.resident ? this.$props.resident : this.residentId,
      filters
    })
  }

  showNotInOrigin (paymentStatus: any) {
    const notSync = !paymentStatus.payment.isSync
    const notHmo = !paymentStatus.payment.hmo
    const isDeclineOrVoid = [EPaymentStatus.DECLINED, EPaymentStatus.VOIDED].includes(paymentStatus.status)
    const isEcheckReject = paymentStatus.payment.residentPaymentMethod && paymentStatus.payment.residentPaymentMethod.type === 'ECHECK' && paymentStatus.payment.rejectPayment
    const facility = this.selectedResident.facility as IFacility
    return notSync && notHmo && !(isDeclineOrVoid && !isEcheckReject) && facility.tempApplyPayment
  }

  toggleReceiptPopup (paymentId: number) {
    this.receiptPaymentId = paymentId
  }

  toggleRefundPopup (payment: IPayment | null) {
    if (this.isUserCanRefund) {
      this.refundPayment = payment
    }
  }

  async showPaymentTransactions (paymentStatus: IPaymentStatus, index: number) {
    if (index === this.openedRowIndex) {
      this.openedRowIndex = -1
      this.openedStatus = null
      return
    }
    this.openedRowIndex = index
    this.openedStatus = paymentStatus
  }

  goTo (options: any) {
    this.$locationManager.rememberAndGoTo(options)
  }

  goToEditPayment (paymentStatus: IPaymentStatus) {
    this.goTo({
      name: 'payment-one-time-edit',
      params: {
        paymentId: (paymentStatus.payment as IPayment).id,
        residentId: ((paymentStatus.payment as IPayment).resident as IResident).id
      }
    })
  }

  showRefundButton (item: IPaymentStatus) {
    const payment = item.payment as IPayment
    if (!this.isUserCanRefund || this.user.isResident() || payment.initialPaymentId) {
      return false
    }
    if ([EPaymentStatus.VOIDED, EPaymentStatus.DECLINED, EPaymentStatus.REFUNDED].includes(item.status)) {
      return false
    }
    if ((payment.residentPaymentMethod as IResidentPaymentMethod).type === EPaymentMethodType.CREDIT_CARD &&
      this.selectedResident && !(this.selectedResident.facility as IFacility).allowCCProcessing) {
      return false
    }
    return true
  }
}
